module.exports = __webpack_public_path__ + "static/apple-9f2a67c5f0c1695bdd4f86c5c1b4db27.jpg";